import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation, Trans } from 'react-i18next';

import { PageSuspendedSvg } from '../../assets/images';
import { SITE_LINKS } from '../../constants';
import { Background } from '../../stories/Background';
import { Button } from '../../stories/Button';
import { Header } from '../../stories/Header';

interface SuspendedPageProps {
  data?: {
    phone?: string;
  };
}

const OE_CONTACT_EMAIL = 'hello@openenglishjunior.com';

export const SuspendedPage: React.FC<SuspendedPageProps> = ({ data }) => {
  const __ = useTranslation().t;

  return (
    <>
      <Header type="logo-only" />
      <Background>
        <div className="oejr-utility-page">
          <Container>
            <Row className="justify-content-center align-items-center">
              <Col sm={12} md={6} className="text-center">
                <PageSuspendedSvg />
              </Col>
              <Col sm={12} md={6}>
                <div className="oejr-utility-page-text-container">
                  <h1 className="oejr-utility-page-header">{__('accountNotActive')}</h1>
                  <p className="oejr-utility-page-description">
                    <Trans
                      alt={__('dontWorrySolutionContactUs')}
                      i18nKey="dontWorrySolutionContactUs"
                      values={{ phone: data?.phone || '' }}
                    >
                      Don’t worry! We have the solution! Send an email to{' '}
                      <a href={`mailto:${OE_CONTACT_EMAIL}`}>{OE_CONTACT_EMAIL}</a> or call us to{' '}
                      <a href={`tel:${data?.phone}`}>{data?.phone ?? ''}</a> and we will help you.
                    </Trans>
                  </p>
                </div>

                <Button label={__('backToLogin')} href={SITE_LINKS.LoginPage} />
              </Col>
            </Row>
          </Container>
        </div>
      </Background>
    </>
  );
};
